import { render, staticRenderFns } from "./vCol.vue?vue&type=template&id=17932a1a"
import script from "./vCol.vue?vue&type=script&lang=js"
export * from "./vCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports